export { default as DonationsModal } from './donations-modal';
